import { render, staticRenderFns } from "./SiteCalendar.vue?vue&type=template&id=0c08db57"
import script from "./SiteCalendar.vue?vue&type=script&lang=js"
export * from "./SiteCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports